import { render, staticRenderFns } from "./Benutzer.vue?vue&type=template&id=f9ca4bd6&scoped=true"
import script from "./Benutzer.vue?vue&type=script&lang=js"
export * from "./Benutzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ca4bd6",
  null
  
)

export default component.exports